import VendorOverviewAdminPartial from "../../../partials/admin/vendors/vendor-overview.admin.partial";

export default function VendorOverviewAdminScreen() {
  return <VendorOverviewAdminPartial />;
}
